//グローバル変数の定義 : コンパイラ、開発環境などのエラーインスペクション用
declare global {
    var navi: {
        loading: Function,
        share: Function,
        formatPrice: Function,
        formatSalesPrice: Function
    };
    var YT: any;
}

export class Bootstrap {
    public static init() {
        this.initNav();
        this.initUi();
        this.initScroll();
        window.addEventListener('load', () => {
            this.initPasswodShow();
            this.initTab();
            this.initOpener();
            this.initEnableBtn();
        });
    }

    private static initScroll(){
        window.addEventListener('scroll', e=> {
            if(window.scrollY > 250){
                document.body.classList.add('is-scroll');
            }else{
                document.body.classList.remove('is-scroll');
            }
        })
        document.querySelectorAll('[data-scroll-top]').forEach( el=>{
            el.addEventListener('click', e=>{
                window.scrollTo(0,0)
            })
        })
    }
    private static initEnableBtn() {

        const btn:any = document.querySelector('[data-enable-btn]');
        if (btn == null) return;
        
        const checks:any = document.querySelectorAll('[data-enable-btn-check]');
        checks.forEach( check =>{
            check.addEventListener('change',()=>{
                let enabled = true;
                checks.forEach((element)=>{
                   const el:any = element;
                   if(!el.checked){
                       enabled = false;
                   }
                });
                if(enabled){
                    btn.disabled = false;
                }else{
                    btn.disabled = true;
                }
            })
        })

    }

    private static initOpener() {
        document.querySelectorAll('[data-opner-head]').forEach(el => {
            el.addEventListener('click', (e) => {
                const head: any = e.currentTarget
                head.closest('[data-opner]').classList.toggle('is-open');
            });
        })
    }

    private static initTab() {
        document.querySelectorAll('[data-tab]').forEach((el) => {
            el.addEventListener('click', (e) => {
                const tab: any = e.currentTarget
                const value = tab.dataset.tab;
                const wrap = tab.closest('[data-tab-wrap]')
                location.hash = value;
                Bootstrap.changeTab(wrap, value);
            })
        })
        Bootstrap.changeTabByHash();
        window.addEventListener('hashchange', Bootstrap.changeTabByHash)
    }

    public static changeTabByHash(e?) {
        document.querySelectorAll('[data-tab-wrap]').forEach(wrap => {
            const hash = location.hash;
            if (hash != '') {
                Bootstrap.changeTab(wrap, hash.replace('#', ''));
            }
        });
    }

    public static changeTab(wrap, value) {
        wrap.querySelectorAll('[data-tab]').forEach(el => {
            if (el.dataset.tab == value) {
                el.classList.add('is-active');
            } else {
                el.classList.remove('is-active');
            }
        })
        wrap.querySelectorAll('[data-tab-content]').forEach(el => {
            if (el.dataset.tabContent == value) {
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        })
    }

    private static initPasswodShow() {
        document.querySelectorAll('[data-role-show-password]').forEach((el) => {
            el.addEventListener('click', e => {
                try {
                    const btn: any = e.currentTarget;
                    const name = btn.dataset.roleShowPassword;
                    const input: any = document.querySelector(`[name="${name}"]`);
                    if (input.type == 'password') {
                        input.type = 'text';
                        btn.innerText = '非表示';
                    } else {
                        input.type = 'password';
                        btn.innerText = '表示';
                    }

                } catch (e) {
                    console.log(e);
                }

            })
        })
    }

    private static initNav() {
        const btn = document.querySelector('.g-nav__btn');
        if (btn) {
            btn.addEventListener('click', this.toggleNav.bind(this))
        }
        const bg = document.querySelector('.g-nav__bg');
        if (bg) {
            bg.addEventListener('click', this.closeNav.bind(this));
        }
        const gnav = document.querySelector('.g-nav');
        if (gnav) {
            gnav.addEventListener('click', (e: any) => {
                if (e.target.tagName == 'A') {
                    Bootstrap.closeNav();
                }
            });
        }
    }

    private static toggleNav(e) {
        if (document.body.classList.contains('is-nav-open')) {
            this.closeNav();
        } else {
            this.openNav();
        }
    }

    private static openNav() {
        let body: any = document.body;
        let top = window.scrollY;
        body.dataset.scroll = top;
        body.style.top = -top + 'px';
        body.classList.add('is-nav-open');
    }

    private static closeNav() {
        let body: any = document.body;
        body.classList.remove('is-nav-open');
        body.style.top = 'auto';
        body.dataset.scroll = null;
    }


    private static initUi() {
        globalThis.navi = {
            loading: this.loading,
            share: this.share,
            formatPrice: this.formatPrice,
            formatSalesPrice: this.formatSalesPrice
        }

        //閉じるボタンイベント
        document
            .querySelectorAll('.popup-close').forEach((el) => {
            el.addEventListener('click', () => {
                Bootstrap.popup(false);
            });
        })

        //クリップボード保存
        const url = document.querySelector('#copyShareUrl');
        if (url) {
            url.addEventListener('click', async function (e: any) {
                e.preventDefault();
                try {
                    await navigator.clipboard.writeText(e.target.dataset.url);
                    document.body.classList.add('is-popup-share-copy');
                    setTimeout(() => {
                        document.body.classList.remove('is-popup-share-copy');
                    }, 3000);
                } catch (err) {
                    alert('コピーに失敗しました。');
                }
            });
        }
    }

    public static formatPrice(price) {
        price /= 10000;//円 > 万円に
        let oku = Math.floor(price / 10000); //億円部分を抽出
        price %= 10000; //万円部分を抽出
        price = price.toLocaleString();
        if (oku > 0) {
            //4桁以下
            if (!String(price).includes(',')) {
                price = String(price).padStart(3, '0'); //3桁のゼロ
                price = '0,' + price;
            }
            let okuValue:any = oku;
            console.log(okuValue);
            //兆円対応の場合
            if(oku >= 10000){
                const cho = Math.floor(oku / 10000); //兆円部分
                oku %= 10000; //億円部分
                okuValue = cho + '兆' + oku.toLocaleString();
            }else{
                okuValue = okuValue.toLocaleString();
            }
            
            return [
                {label: '億', value: okuValue},
                {label: '万円', value: price}
            ]
        }

        return [
            {label: '万円', value: price}
        ]
    }

    public static formatSalesPrice(price) {
        price /= 100000000;//円 > 億円に
        const cho = Math.floor(price / 10000); //兆円部分を抽出
        price %= 10000; //億円部分を抽出
        price = Math.floor(price); //億円以下は切り捨て
        price = price.toLocaleString();
        if (cho > 0) {
            //4桁以下
            if (!String(price).includes(',')) {
                price = String(price).padStart(3, '0'); //3桁のゼロ
                price = '0,' + price;
            }
            return [
                {label: '兆', value: cho},
                {label: '億円', value: price}
            ]
        }
        return [
            {label: '億円', value: price}
        ]
    }

    public static loading(toLoading: boolean = true) {
        if (toLoading) {
            document.body.classList.add('is-loading');
        } else {
            document.body.classList.remove('is-loading');
        }
    }

    public static popup(toPopup: boolean = true) {
        if (toPopup) {
            document.body.classList.add('is-popup');
        } else {
            document.body.classList.remove('is-popup');
            document.body.classList.remove('is-popup-share');
            document.body.classList.remove('is-popup-save');
            document.body.classList.remove('is-popup-login');
        }
    }


    public static share(company: any) {
        //シェアURL設定
        let mail_share_url = company.mail_share_url;
        let line_url = company.line_share_url;
        let input: HTMLInputElement | null = document.querySelector('#shareUrl');
        let mail: HTMLAnchorElement | null = document.querySelector('#shareLinkMail');
        let line: HTMLAnchorElement | null = document.querySelector('#shareLinkLine');
        let btn: HTMLButtonElement | null = document.querySelector('#copyShareUrl');
        
        let url = `${location.protocol}//${location.host}/companies/${company.company_id}`;
        
        if (mail) {
            mail.href = mail_share_url;
        }
        if (line) {
            line.href = line_url;
        }
        if (input) {
            input.value = url;
        }
        if (btn) {
            btn.dataset.url = url;
        }
        Bootstrap.popup();
        document.body.classList.add('is-popup-share');
    }

    public static save() {
        Bootstrap.popup();
        document.body.classList.add('is-popup-save');
    }

    public static login() {
        Bootstrap.popup();
        document.body.classList.add('is-popup-login');
    }


}
